import { Link } from "react-router-dom";
import { useCart } from "@/context/CartContext";
import { ShoppingCart } from "lucide-react";
import { toast } from "sonner";

export function ProductCard({ product }) {
  const { addItem, setIsOpen } = useCart();

  const handleAdd = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (product.option_groups?.length || product.options?.length) {
      window.location.href = `/product/${product.slug}`;
      return;
    }
    addItem(product);
    setIsOpen(true);
    toast.success(`${product.name} added to cart`);
  };

  return (
    <Link
      to={`/product/${product.slug}`}
      className="card-glow group relative block border border-white/10 bg-surface transition-all hover:border-volt"
      data-testid={`product-card-${product.slug}`}
    >
      <div className="relative aspect-square overflow-hidden">
        <img
          src={product.image_url}
          alt={product.name}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        {product.badge && (
          <span className="absolute left-3 top-3 bg-volt px-2 py-1 font-mono text-xs font-bold uppercase text-obsidian" data-testid={`product-badge-${product.slug}`}>
            {product.badge}
          </span>
        )}
        {product.stock === 0 && (
          <span className="absolute inset-0 flex items-center justify-center bg-black/70 font-mono text-sm uppercase tracking-widest text-white" data-testid={`product-outofstock-${product.slug}`}>
            Out of Stock
          </span>
        )}
      </div>
      <div className="p-4">
        <p className="font-mono text-xs uppercase tracking-widest text-slate-500">{product.category}</p>
        <h3 className="mt-1 font-display text-xl font-bold uppercase tracking-tight text-white group-hover:text-volt">
          {product.name}
        </h3>
        <div className="mt-3 flex items-center justify-between">
          <span className="font-mono text-lg font-bold text-volt" data-testid={`product-price-${product.slug}`}>
            ${product.price.toFixed(2)}
          </span>
          <button
            onClick={handleAdd}
            disabled={product.stock === 0}
            className="rounded-sm bg-volt p-2 text-obsidian transition-colors hover:bg-white disabled:opacity-30"
            data-testid={`add-to-cart-${product.slug}`}
          >
            <ShoppingCart className="h-4 w-4" />
          </button>
        </div>
      </div>
    </Link>
  );
}
